import React, { Component, Fragment } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { ToastContainer } from "react-toastify";
import CreateSaq from "../../components/CreateSaq";
//import CompletedSaqs from "../../components/CompletedSaqs";

import { callApiSaqsFind, callApiUpdateUserPassword } from "../../services";
import { authUserData } from "../../helpers";
import SaqLists from "../../components/SaqLists";

class BusinessSelection extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      draftSaqData: null,
      completedSaqData: null,
    };
  }

  componentDidMount = async () => {
    const userData = authUserData();

    /* const tempPassword = await this.makeTempPassword();
    const userId = userData && userData.userId;
    callApiUpdateUserPassword(userId, { password: tempPassword }).then(
      (resData) => {
        
      }
    ); */

    callApiSaqsFind({ userId: userData.userId })
      .then((res) => {
        // console.log("api res", res);
        if (res.success && res.data && res.data.length > 0) {
          const draftList = res.data.filter((v, i) => {
            return v.status === "draft";
          });

          const completedList = res.data.filter((v, i) => {
            return v.status === "completed";
          });

          // console.log("completedList", completedList);

          this.setState({
            draftSaqData: draftList,
            completedSaqData: completedList,
          });
        }
      })
      .catch((error) => {
        // console.log("BusinessSelection fetch saq data ... error", error);
      });
  };

  makeTempPassword(length) {
    var result = [];
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@#$%^&*()-=";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result.push(
        characters.charAt(Math.floor(Math.random() * charactersLength))
      );
    }
    return result.join("");
  }

  render() {
    const { history } = this.props;
    const { draftSaqData, completedSaqData } = this.state;

    return (
      <Fragment>
        <ToastContainer />
        <div className="d-flex flex-column min-vh-100 justify-content-center align-items-center">
          <h3>Please choose your business</h3>
          <div className="form-group">
            <select className="form-control" id="sel1" onChange={() => {}}>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
            </select>
          </div>
          <button className="btn btn-primary" disabled={true}>
            Go to Dasboard
          </button>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    res: state.authStore.res,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(BusinessSelection);
